import { Component } from 'react'
import { Box, Button, Tab, EncodingDailyItems, AntennaStatus } from 'stylewhere/components'
import { EncodingExtensions } from 'stylewhere/extensions'
import { __, T } from 'stylewhere/i18n'
import { EncodingOperationConfig } from 'stylewhere/shared/RemoteOperation'
import { getEncodingAuditLogURL, isEncodingAuditLogEnabled } from 'stylewhere/utils'
import { OperationEncodingTagType } from 'stylewhere/types'

interface Props {
  operation: EncodingOperationConfig
  options: any
  antennaOn?: boolean
  antennaTagType?: OperationEncodingTagType
  onTabClick?: any
  children?: any
  onResetDailyEncodedItems?: () => void
}

export class EncodingRightHeader extends Component<Props> {
  render() {
    const { operation, options, antennaOn, antennaTagType, onTabClick, children, onResetDailyEncodedItems } = this.props
    const showEncodingAuditLog = isEncodingAuditLogEnabled() && !!getEncodingAuditLogURL()
    return (
      <Box row>
        {showEncodingAuditLog && (
          <Button
            style={{ marginRight: 10, borderRadius: 15 }}
            variant="primary"
            type="button"
            // built on click: the day range must be today's even if the page stayed open past midnight
            onClick={() => {
              const url = getEncodingAuditLogURL()
              if (url) window.open(url, '_blank')
            }}
          >
            {__(T.misc.encoding_audit_log)}
          </Button>
        )}
        {children ?? null}
        <EncodingDailyItems
          code={operation.code}
          style={{ minWidth: 130, marginRight: 10, borderRadius: 15 }}
          onPress={onResetDailyEncodedItems}
        />
        <Box mr={0} vcenter>
          <Tab
            onclick={onTabClick}
            options={options}
            onOptionSelected={(opt) => EncodingExtensions.getOptionEncodingPage(opt, operation)}
          />
        </Box>
        <AntennaStatus started={antennaOn || false} tagType={antennaTagType} />
      </Box>
    )
  }
}
